<script setup lang="ts">
const page = usePage()
const appStore = useAppStore()
const restaurantStore = useRestaurantStore()

const dataCategories = computed(() => {
  if (!restaurantStore.isRestaurantSelected || !restaurantStore.areaSelected) return undefined
  return {
    categories: appStore.categories || [],
    restaurantInfo: restaurantStore.restaurant!,
    area: restaurantStore.areaSelected,
  }
})
</script>

<template>
  <main>
    <!-- Menu of restaurant selected -->
    <CategoryHorizontalMenu
      v-if="dataCategories?.categories"
      :categories="dataCategories.categories"
      :restaurant-info="dataCategories.restaurantInfo"
      :area="dataCategories.area"
    />
    <!-- Static Menu -->
    <CategoryHorizontalMenu v-else />

    <div
      v-for="block in page.blocks"
      :key="block.__component + block.id"
      :data-block="block.__component"
    >
      <Block :block="block" critical />
    </div>
  </main>
</template>

<style scoped>
/*  
  THIS STYLE ADD A BOTTOM MARGIN IF IS THE LAST ONE
*/
[data-block='block.card']:last-child,
[data-block='block.rich-text']:last-child,
[data-block='block.carousel-wide']:last-child,
[data-block='block.accordion']:last-child,
[data-block='block.collapsable-menu']:last-child,
[data-block='block.featured-tile']:last-child,
[data-block='block.background-tiles']:last-child,
[data-block='block.marketing-cards']:last-child,
[data-block='block.text-full-screen']:last-child,
[data-block='block.header-tile']:last-child,
[data-block='block.tile-banner-full']:last-child,
[data-block='block.slider-full-texts']:last-child,
[data-block='block.banner-tiles']:last-child,
[data-block='block.scroll-cards']:last-child,
[data-block='block.contact-form']:last-child {
  @apply mb-[120px];
}
</style>
